import isArticleCoverColor from './isArticleCoverColor';

export default isArticleCoverColor;
